import { DnD_element_type_menu } from '../common/ConstantValues';
import { DnD_element_type } from '../common/ConstantValues';

export const allowed_types_component_menu = [
  DnD_element_type_menu.COMPONENT.NORMAL.TEXT,
  DnD_element_type_menu.COMPONENT.NORMAL.BUTTON,
  DnD_element_type_menu.COMPONENT.NORMAL.IMAGE,
  DnD_element_type_menu.COMPONENT.NORMAL.GROUP,
  DnD_element_type_menu.COMPONENT.SPECIAL.ADDR,
  DnD_element_type_menu.COMPONENT.SPECIAL.TEL,
  DnD_element_type_menu.COMPONENT.SPECIAL.DATE,
]
export const allowed_types_component_menu_without_group = [
  DnD_element_type_menu.COMPONENT.NORMAL.TEXT,
  DnD_element_type_menu.COMPONENT.NORMAL.BUTTON,
  DnD_element_type_menu.COMPONENT.NORMAL.IMAGE,
  DnD_element_type_menu.COMPONENT.SPECIAL.ADDR,
  DnD_element_type_menu.COMPONENT.SPECIAL.TEL,
  DnD_element_type_menu.COMPONENT.SPECIAL.DATE,
]

export const allowed_types_component = [
  DnD_element_type.COMPONENT.NORMAL.TEXT.outDepth,
  DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth,
  DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth,
  DnD_element_type.COMPONENT.NORMAL.GROUP,
  DnD_element_type.COMPONENT.SPECIAL.ADDR,
  DnD_element_type.COMPONENT.SPECIAL.TEL,
  DnD_element_type.COMPONENT.SPECIAL.DATE,
]
export const allowed_types_component_with_indepth = [
  DnD_element_type.COMPONENT.NORMAL.TEXT.outDepth,
  DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth,
  DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth,
  DnD_element_type.COMPONENT.NORMAL.TEXT.inDepth,
  DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth,
  DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth,
  DnD_element_type.COMPONENT.NORMAL.GROUP,
  DnD_element_type.COMPONENT.SPECIAL.ADDR,
  DnD_element_type.COMPONENT.SPECIAL.TEL,
  DnD_element_type.COMPONENT.SPECIAL.DATE,
]
/**
 * SliderViewPageDetail 에서 사용함
 */
export const allowed_types_component_without_group = [
  DnD_element_type.COMPONENT.NORMAL.TEXT.inDepth,
  DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth,
  DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth,
  // DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth,
  // DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth,
  // DnD_element_type.COMPONENT.SPECIAL.ADDR,
  // DnD_element_type.COMPONENT.SPECIAL.TEL,
  // DnD_element_type.COMPONENT.SPECIAL.DATE,
]